document.documentElement.classList.add('js');
// Production safety: external links opened in a new tab should not retain opener access.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[target="_blank"]').forEach(function (a) {
    var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    if (!rel.includes('noopener')) rel.push('noopener');
    a.setAttribute('rel', rel.join(' '));
  });
});

// v7.4 — instant collection filtering/sorting without an Apply click.
(function () {
  function initInstantFilters(scope) {
    (scope || document).querySelectorAll('.filter-form').forEach(function (form) {
      if (form.dataset.instantReady) return;
      form.dataset.instantReady = 'true';
      var timer;
      form.querySelectorAll('input[type="checkbox"], select').forEach(function (control) {
        control.addEventListener('change', function () { instantSubmit(form); });
      });
      form.querySelectorAll('.price-filter input').forEach(function (control) {
        control.addEventListener('input', function () {
          clearTimeout(timer);
          timer = setTimeout(function () { instantSubmit(form); }, 550);
        });
      });
    });
  }

  function instantSubmit(form) {
    var params = new URLSearchParams(new FormData(form));
    var url = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    var results = document.querySelector('.collection-results');
    if (results) results.classList.add('is-loading');
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) { if (!response.ok) throw new Error('Filter request failed'); return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextResults = doc.querySelector('.collection-results');
        var nextDesktop = doc.querySelector('.desktop-filter');
        var nextMobile = doc.querySelector('.mobile-filter-panel');
        if (!nextResults) { window.location.assign(url); return; }
        document.querySelector('.collection-results').replaceWith(nextResults);
        if (nextDesktop && document.querySelector('.desktop-filter')) document.querySelector('.desktop-filter').replaceWith(nextDesktop);
        if (nextMobile && document.querySelector('.mobile-filter-panel')) document.querySelector('.mobile-filter-panel').replaceWith(nextMobile);
        history.pushState({}, '', url);
        initInstantFilters(document);
      })
      .catch(function () { window.location.assign(url); });
  }

  document.addEventListener('DOMContentLoaded', function () { initInstantFilters(document); });
  window.addEventListener('popstate', function () { window.location.reload(); });
})();
